const getFormattedCurrentDate = () => {
  const now = new Date();

  const formattedDate =
    (now.getMonth() + 1 + '').padStart(2, '0') +
    '/' +
    (now.getDate() + '').padStart(2, '0') +
    '/' +
    now.getFullYear();

  return formattedDate;
};

export default getFormattedCurrentDate;
